import gql from 'graphql-tag'

export const BELL = gql`
  query bell($orgId: String!) {
    orgs(id: $orgId) {
      success
      reason
      results {
        ... on Org {
          id
          class
          state
          data {
            id
            type
            value
          }
          sshKeys {
            id
          }
        }
      }
    }
  }
`
